// extracted by mini-css-extract-plugin
export var avatarContainer = "_i6-0";
export var avatarTypingWave = "_i6-i";
export var gray = "_i6-f";
export var green = "_i6-c";
export var icon = "_i6-9";
export var image = "_i6-1";
export var lg = "_i6-6";
export var md = "_i6-5";
export var presenceDot = "_i6-b";
export var red = "_i6-d";
export var sm = "_i6-4";
export var status = "_i6-a";
export var typingDot = "_i6-h";
export var typingPill = "_i6-g";
export var xl = "_i6-7";
export var xs = "_i6-3";
export var xxl = "_i6-8";
export var xxs = "_i6-2";
export var yellow = "_i6-e";